/**
 * Company-name normalisation shared by the resolver and the asset vendoring script, so
 * "Apple Inc", "APPLE INC-CLASS A" and "Apple" all land on the same key.
 */

const NOISE = new Set(
  (
    "inc incorporated corp corporation co company ag se sa nv plc ltd limited holdings holding hlds group the " +
    "class cl a b c adr ads spon sp spons sponsored ordinary shares common stock oyj asa ab spa kgaa na de cfd"
  ).split(" "),
);

export function normaliseBrandName(name: string): string {
  return name
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/\.com\b/g, "")
    .replace(/[^a-z0-9 ]+/g, " ")
    .split(" ")
    .filter((word) => word && !NOISE.has(word))
    .join(" ");
}

/** Exchange suffix on a share symbol → market, so AAPL.O, AAPL.OQ and AAPL.US are one company. */
export const STOCK_MARKETS: Record<string, string> = {
  O: "US", OQ: "US", N: "US", A: "US", US: "US",
  L: "GB", DE: "DE", F: "DE", PA: "FR", S: "CH", AS: "NL", BR: "BE", LS: "PT",
  MI: "IT", MC: "ES", ST: "SE", OL: "NO", CO: "DK", HE: "FI", VI: "AT", HK: "HK", T: "JP", AX: "AU", TO: "CA",
};
